export const scaleTransformFoo = (size, scale, factor = 0.5) => {
    return size / Math.pow(scale, factor);
};
